<template>
  <validation-provider
    #default="{ errors }"
    :name="defaultName"
    :vid="id"
    :rules="rules"
    mode="passive"
  >
    <b-form-group :label="label" :label-for="id">
      <v-select
        :getOptionLabel="getOptionLabel()"
        :reduce="reduce()"
        :closeOnSelect="false"
        multiple
        :options="options"
        :name="name"
        :dir="isRTL"
        :id="id"
        :loading="loading"
        v-bind="$attrs"
        v-on="$listeners"
        :class="{ 'has-error': errors.length > 0 && values.length === 0 }"
        :selectable="canSelect"
        ref="classSelect"
        @input="values = $event"
      >
        <template v-for="(index, name) in $scopedSlots" v-slot:[name]="data">
          <slot :name="name" v-bind="data"></slot>
        </template>
        <template #no-options> لا يوجد نتائج لعرضها </template>
        <template #spinner="{ loading }">
          <b-spinner
            small
            variant="primary"
            v-if="loading"
          ></b-spinner> </template
      ></v-select>
      <small
        class="text-danger"
        v-if="errors.length > 0 && values.length === 0"
      >
        {{ errors[0] }}
      </small>
    </b-form-group>
  </validation-provider>
</template>

<script>
import { ValidationProvider } from "vee-validate";
import vSelect from "vue-select";
import { BFormGroup, BSpinner } from "bootstrap-vue";
import store from "../form-select/store";
import { $themeConfig } from "@themeConfig";
import { required } from "@validations";

export default {
  components: {
    ValidationProvider,
    vSelect,
    BSpinner,
    BFormGroup,
  },
  props: {
    id: {
      type: String,
      default: () => "class-select",
    },
    name: {
      type: String,
    },
    legalForm: {
      type: String,
    },
    rules: {
      type: String,
      default: () => "",
    },
    label: {
      type: String,
      default: () => "التصنيف",
    },
    ep: {
      type: String,
      default: () => "v2/guest/selects/classifications",
    },
    dataPath: {
      type: String,
      default: () => "data",
    },
    getOptionLabel: {
      type: Function,
      default: () => {
        const mapper = (x) => x.name_ar;
        return mapper;
      },
    },
    reduce: {
      type: Function,
      default: () => {
        const mapper = (x) => x.id;
        return mapper;
      },
    },
  },
  data() {
    return {
      required,
      values: [],
    };
  },
  watch: {
    legalForm() {
      this.values = [];
      this.$emit("input", []);
    },
  },
  computed: {
    isRTL() {
      return $themeConfig.layout.isRTL ? "rtl" : "ltr";
    },
    options() {
      return this.$store.getters[`${this.id}/options`] || this.$attrs.options;
    },
    loading() {
      return this.$store.getters[`${this.id}/loading`];
    },
    defaultName() {
      return this.name || this.label;
    },
  },
  methods: {
    canSelect() {
      return (
        (this.legalForm === "association" && this.values.length < 1) ||
        (this.legalForm === "institution" && this.values.length < 2) ||
        (this.legalForm !== "institution" && this.legalForm !== "association")
      );
    },
    refreshOptions(val) {
      if (this.$store.hasModule(this.id)) {
        this.$store.dispatch(`${this.id}/fetchOptions`, {
          ep: val || this.ep,
          path: this.dataPath,
        });
      }
    },
  },
  created() {
    if (this.ep && !this.$attrs.options && !this.$store.hasModule(this.id)) {
      this.$store.registerModule(this.id, store);
      if (this.ep.length > 1) {
        this.$store.dispatch(`${this.id}/fetchOptions`, {
          ep: this.ep,
          path: this.dataPath,
        });
      }
    }
    this.values = this.$attrs.value || [];
  },
  beforeDestroy() {
    if (this.$store.hasModule(this.id)) {
      this.$store.unregisterModule(this.id);
    }
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";

.has-error {
  .vs__dropdown-toggle {
    border: 1px solid #ea5455 !important;
  }
}
.vs__dropdown-toggle {
  background-color: var(--white);
}
</style>
